
import React from 'react';
import { Button } from '@/components/ui/button';
import { MessageSquare } from 'lucide-react';

interface ClubRestrictedContentProps {
  onJoinClub: () => void;
  joiningClub: boolean;
}

const ClubRestrictedContent: React.FC<ClubRestrictedContentProps> = ({ onJoinClub, joiningClub }) => {
  return (
    <div className="text-center py-8">
      <MessageSquare className="h-12 w-12 mx-auto text-muted-foreground mb-2" />
      <h3 className="text-lg font-medium mb-2">Join to participate in discussions</h3>
      <p className="text-muted-foreground mb-4">You need to be a member to view and participate in discussions</p>
      <Button onClick={onJoinClub} disabled={joiningClub}>
        {joiningClub ? "Processing..." : "Join Club"}
      </Button>
    </div>
  );
};

export default ClubRestrictedContent;
